import enAccount from './locales/en/account.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enProjects from './locales/en/projects.json';
import enReport from './locales/en/report.json';
import enTools from './locales/en/tools.json';
import enErrors from './locales/en/errors.json';
import enLandcover from './locales/en/landcover.json';
import enSite from './locales/en/site.json';
import enValidation from './locales/en/validation.json';
import msAccount from './locales/ms/account.json';
import msAuth from './locales/ms/auth.json';
import msCommon from './locales/ms/common.json';
import msProjects from './locales/ms/projects.json';
import msReport from './locales/ms/report.json';
import msTools from './locales/ms/tools.json';
import msErrors from './locales/ms/errors.json';
import msLandcover from './locales/ms/landcover.json';
import msSite from './locales/ms/site.json';
import msValidation from './locales/ms/validation.json';

/**
 * Every catalogue, bundled.
 *
 * Statically imported rather than fetched at runtime: there are two locales and
 * a few kilobytes of strings, and a network round trip before first paint would
 * cost more than the bytes save. It also means the landing site's static
 * prerender has every string available at build time, with no loading state to
 * design for a translation that is already in the bundle.
 *
 * English is the shape authority — `resources.d.ts` derives the key types from
 * it, so a key that exists only in Malay is invisible to the type system and a
 * key missing from Malay is caught by `resources.test.ts` instead.
 *
 * On `landcover`: PRD §9.3 WS-9 keeps domain terms in Malay in *both* locales,
 * so `label` is identical across the two files by design — `Bangunan` stays
 * `Bangunan` for an English-speaking planner, because that is the word on the
 * cadastre. `gloss` carries the English rendering shown on first use; the Malay
 * UI simply does not render it.
 */
export const resources = {
  en: {
    common: enCommon,
    errors: enErrors,
    validation: enValidation,
    landcover: enLandcover,
    site: enSite,
    auth: enAuth,
    account: enAccount,
    projects: enProjects,
    report: enReport,
    tools: enTools,
  },
  ms: {
    common: msCommon,
    errors: msErrors,
    validation: msValidation,
    landcover: msLandcover,
    site: msSite,
    auth: msAuth,
    account: msAccount,
    projects: msProjects,
    report: msReport,
    tools: msTools,
  },
} as const;

export type Resources = typeof resources;
